import React from 'react';
import './Testimonials.css';
import siteContent from '../../data/siteContent';

const Testimonials = () => {
  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-section__inner">
        <div className="section-heading">
          <h2 className="section-heading__title">TESTIMONIALS</h2>
        </div>

        <div className="testimonials-grid">
          {siteContent.testimonials.map((testimonial) => (
            <article className="testimonial-card" key={testimonial.name}>
              <p className="testimonial-card__quote">“{testimonial.quote}”</p>
              <div className="testimonial-card__meta">
                <h3>{testimonial.name}</h3>
                <p>{testimonial.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;